/* eslint-disable */

import React, { Component } from 'react';
import { Button, Table, Dropdown } from 'semantic-ui-react';

import './AdBlueprintList.css';
import _ from 'lodash';

class AdBlueprintList extends Component {
  state = {
    pages: [],
    selectedPage: '',
    selectedToken: '',
    showConfirm: false
  };

  deleteAdBlueprint = (e, { data }) => {
    this.props.deleteAdBlueprint(this.state.deleteRowId);
  };

  openDialog = (e, { data }) => {
    this.setState({ showConfirm: true, deleteRowId: data.id });
  };

  handleCancel = () => {
    this.setState({ showConfirm: false });
  };

  getAccountName = (accountId) => {
    const account = this.props.accounts.find(
      (acct) => acct.value === accountId
    );
    if (account) {
      return account.text;
    }

    return '';
  };

  editAdBlueprint = (e, { data }) => {
    this.props.editAdBlueprint(data.id);
  };

  render() {
    if (this.props.adBlueprints) {
      return (
        <div>
          {this.props.accounts.length !== 0 && this.props.pages.length !== 0 ? (
            <div className="new-adBlueprint-link">
              <a href="#" onClick={this.props.newAdBlueprint}>
                NEW AD +
              </a>
            </div>
          ) : null}
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell className="row-name">Name</Table.HeaderCell>
                <Table.HeaderCell className="row-account">
                  Ad Account
                </Table.HeaderCell>
                <Table.HeaderCell className="row-type">Type</Table.HeaderCell>
                <Table.HeaderCell className="row-by">
                  Created By
                </Table.HeaderCell>
                <Table.HeaderCell className="row-date">
                  Created At
                </Table.HeaderCell>
                <Table.HeaderCell className="row-by">
                  Updated By
                </Table.HeaderCell>
                <Table.HeaderCell className="row-date">
                  Updated At
                </Table.HeaderCell>
                <Table.HeaderCell className="row-operations">
                  Operations
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {this.props.adBlueprints.adBlueprints.list.map((blueprint) => (
                <Table.Row key={blueprint.id}>
                  <Table.Cell>{blueprint.name}</Table.Cell>
                  <Table.Cell>
                    {this.getAccountName(blueprint.adAccount)}
                  </Table.Cell>
                  <Table.Cell>{blueprint.adType}</Table.Cell>
                  <Table.Cell>{blueprint.createdBy}</Table.Cell>
                  <Table.Cell>
                    {new Date(
                      Date.parse(blueprint.createdAt)
                    ).toLocaleString('en-us', {
                      month: 'long',
                      day: '2-digit',
                      year: 'numeric',
                      hour: 'numeric',
                      minute: 'numeric'
                    })}
                  </Table.Cell>
                  <Table.Cell>{blueprint.updatedBy}</Table.Cell>
                  <Table.Cell>
                    {new Date(
                      Date.parse(blueprint.updatedAt)
                    ).toLocaleString('en-us', {
                      month: 'long',
                      day: '2-digit',
                      year: 'numeric',
                      hour: 'numeric',
                      minute: 'numeric'
                    })}
                  </Table.Cell>
                  <Table.Cell className="column-operations">
                    {this.state.showConfirm &&
                    blueprint.id === this.state.deleteRowId ? (
                      <div className="div-confirm">
                        <p className="text-confirm">Are you sure?</p>
                        <Button
                          onClick={this.deleteAdBlueprint}
                          size="mini"
                          color="grey"
                        >
                          Yes
                        </Button>
                        <Button
                          onClick={this.handleCancel}
                          size="mini"
                          color="red"
                        >
                          No
                        </Button>
                      </div>
                    ) : (
                      <div>
                        <Button
                          data={{ id: blueprint.id }}
                          onClick={this.editAdBlueprint}
                          size="small"
                          color="blue"
                          disabled={
                            this.props.accounts.length === 0 &&
                            this.props.pages.length !== 0
                          }
                          className="button-delete-bluprint operation-button"
                        >
                          Edit
                        </Button>
                        <Button
                          data={{ id: blueprint.id }}
                          onClick={this.openDialog}
                          size="small"
                          color="blue"
                          className="button-delete-bluprint operation-button"
                        >
                          Delete
                        </Button>
                      </div>
                    )}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
      );
    }
    return null;
  }
}

export default AdBlueprintList;



// WEBPACK FOOTER //
// ./src/screens/AdBlueprint/AdBlueprintList.js